module.exports = __webpack_public_path__ + "assets/favicons/favicon.7287f4fb7e6f0682787b23afeea07949.ico";